import { SignIn } from "@freshservice/bridge";
import { IS_PRO } from "@fresh/env";

/* eslint-disable */
export default class SignInMart extends SignIn {
    constructor(args) {
        super(args);
        this.baseWechatUrl =
            !IS_PRO
                ? "https://wechatz.34580.com/mart/#"
                : "https://wechatx.34580.com/mart/#";
        const queryArray = args["queryArray"];
        this.wechatUrl =
            `/sign/in?service=${encodeURIComponent(
                window.location.origin +
                    window.location.pathname +
                    window.location.hash
            )}` + `&${queryArray.join("&")}`;
    }
}
